import React, { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";

import {
  Box,
  CircularProgress,
  Grid,
  Tooltip,
  IconButton,
  Dialog,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  TextField,
  Menu,
} from "@mui/material";

import ContactCard from "./ContactCard";
import NewContact from "./NewContact";
import ContactDetailsModal from "./ContactDetailsModal";
import AddEditContactDialog from "./AddEditContactDialog";
import ContactDetails from "./ContactDetails";
import Loader from "../Components/Loader";
import useWindowDimensions from "../Hooks/useWindowDimensions";
import "./Contact.css";
import { getCustomer, mergeCustomer } from "../Store/Actions/ContactAction";
import KnowledgeBase1 from "../Documents/Knowledge-Base-1.pdf";
import KnowledgeBase2 from "../Documents/Knowledge-Base-2.pdf";
import NewWindow from "react-new-window";

export default function Contact({ changePage, setIsBroadcastContactShown }) {
  const { isInACW, phoneNumber, showContactModal } = useSelector(
    (state) => state.call
  );

  const [name, setName] = useState("");
  const [ref, setRef] = useState("");
  const [keyword, setKeyword] = useState("");
  const [sort, setSort] = useState("ASC");
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true); // For infinite scroll
  const [contact, setContact] = useState([]); // The actual contacts
  const [contactList, setContactList] = useState([]); // The list of items in each contact (e.g. mobile, fb, twitter, ig, etc.)
  const [isLoading, setIsLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);

  const [isContactDetailsModalShown, setIsContactDetailsModalShown] =
    useState(false);

  const [isAddEditContactDialogShown, setIsAddEditContactDialogShown] =
    useState(false);

  const [isSearchShown, setIsSearchShown] = useState(false);
  const [anchorElKnowledgeBase, setAnchorElKnowledgeBase] = useState(null);
  const [selected, setSelected] = useState(null);
  const [selectedKnowledgeBase, setSelectedKnowledgeBase] = useState(null);
  const [isLinking, setIsLinking] = useState(false);

  const [isMergeWarningDialogShown, setIsMergeWarningDialogShown] =
    useState(false);

  const [mergeSource, setMergeSource] = useState(null);
  const [mergeSourceCard, setMergeSourceCard] = useState(null);
  const [mergeDestination, setMergeDestination] = useState(null);
  const [isProcessingMerge, setIsProcessingMerge] = useState(false);
  const { width } = useWindowDimensions();

  // Search contact on inbound call
  useEffect(() => {
    function convertPhoneNumber(number) {
      if (number.startsWith("+")) {
        return number.slice(1);
      }

      // For WABA call
      if (number.startsWith("999")) {
        return number.slice(3);
      }

      return number;
    }

    if (phoneNumber) {
      setKeyword(convertPhoneNumber(phoneNumber));
      fetchCustomer(convertPhoneNumber(phoneNumber));
    } else if (phoneNumber === null && isInACW) {
      setIsAddEditContactDialogShown(true);
    }
  }, [phoneNumber, showContactModal]);

  const fetchCustomer = (keyword, page = 1, sort = "ASC", name, ref) => {
    setHasMore(true);

    getCustomer(keyword, page, sort, name, ref)
      .then((response) => {
        if (response.status) {
          // Stop fetching when all data has been fetched
          if (contact.length >= response.data.total) {
            setHasMore(false);
            setIsLoading(false);
          }

          // If page is set to 1, reset the state
          if (page === 1) {
            if (isLinking) {
              setContact([
                mergeSourceCard,
                ...response.data.customers.filter(
                  (item) => item.ContactID !== selected
                ),
              ]);
            } else {
              setContact(response.data.customers);
            }

            setContactList(response.data.customers_phone);
          } else {
            // Else, update the state
            if (isLinking) {
              setContact([
                mergeSourceCard,
                ...contact.filter((item) => item.ContactID !== selected),
                ...response.data.customers,
              ]);
            } else {
              setContact([...contact, ...response.data.customers]);
            }

            setContactList([...contactList, ...response.data.customers_phone]);
          }

          setCurrentPage(page + 1);
          setIsLoading(false);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    !phoneNumber && fetchCustomer();
  }, []);

  useEffect(() => {
    if (isLinking) {
      if (mergeSourceCard === null) {
        setMergeSourceCard(contact.find((item) => item.ContactID === selected));
      }

      const rearrangedContact = [
        contact.find((item) => item.ContactID === selected),
        ...contact.filter((item) => item.ContactID !== selected),
      ];

      setContact(rearrangedContact);
      /* } else {
      setIsLoading(true);
      phoneNumber ? fetchCustomer(phoneNumber) : fetchCustomer(); */
    }
  }, [isLinking]);

  const openKnowledgeBase = Boolean(anchorElKnowledgeBase);

  const handleClickKnowledgeBase = (event) =>
    setAnchorElKnowledgeBase(event.currentTarget);

  const handleCloseKnowledgeBase = () => setAnchorElKnowledgeBase(null);

  const handleCloseMerge = () => {
    setIsMergeWarningDialogShown(false);
    setMergeSource({});
    setMergeSourceCard(null);
    setMergeDestination({});
    setIsLinking(false);
    setSelected(null);
  };

  return (
    <div className="Contact">
      <div className="list_header">
        <div className="list_headerLeft">
          {width <= 1200 && selected !== null && (
            <Icon
              icon="material-symbols:arrow-back-ios-new-rounded"
              width="32"
              height="32"
              onClick={() => setSelected(null)}
            />
          )}

          <h1>
            {width <= 1200 && selected !== null
              ? "Contact Details"
              : `${isLinking ? "Link " : ""}Contact`}
          </h1>
        </div>
      </div>

      {width <= 1200 && selected !== null ? null : (
        <div className="containerContact">
          {/* ini yang box putih */}
          <div className="container_Header">
            {isSearchShown ? (
              <div className="search">
                <div className="row">
                  <div className="row_left">
                    <div className="position_left">
                      <div className="single_button">
                        <Tooltip title="Close" arrow>
                          <IconButton
                            size="medium"
                            onClick={() => setIsSearchShown(false)}
                          >
                            <Icon icon="ph:x-bold" width="28" height="28" />
                          </IconButton>
                        </Tooltip>
                      </div>
                      <div className="field_Container">
                        <TextField
                          className="textfieldRow1"
                          label="Contact Name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                        <TextField
                          className="textfieldRow1"
                          label="Contact Ref"
                          value={ref}
                          onChange={(e) => setRef(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="Contact_Container_right">
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        <div className="single_button">
                          <Tooltip title="Show knowledge base" arrow>
                            <IconButton
                              size="medium"
                              onClick={handleClickKnowledgeBase}
                            >
                              <Icon
                                height="26"
                                icon="material-symbols:quick-reference-outline"
                              />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </Box>

                      <Menu
                        anchorEl={anchorElKnowledgeBase}
                        open={openKnowledgeBase}
                        onClose={handleCloseKnowledgeBase}
                        onClick={handleCloseKnowledgeBase}
                        anchorOrigin={{ horizontal: -80, vertical: 70 }}
                      >
                        <MenuItem
                          onClick={() =>
                            setSelectedKnowledgeBase(KnowledgeBase1)
                          }
                        >
                          Knowledge Base 1.pdf
                        </MenuItem>

                        <MenuItem
                          onClick={() =>
                            setSelectedKnowledgeBase(KnowledgeBase2)
                          }
                        >
                          Knowledge Base 2.pdf
                        </MenuItem>
                      </Menu>

                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        <div className="single_button">
                          <Tooltip title="Broadcast" arrow>
                            <IconButton
                              size="medium"
                              onClick={() => setIsBroadcastContactShown(true)}
                            >
                              <Icon
                                height="26"
                                icon="fluent:megaphone-loud-32-filled"
                              />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        <div className="single_button">
                          <Tooltip title="Add Contact" arrow>
                            <IconButton
                              size="medium"
                              onClick={() =>
                                setIsAddEditContactDialogShown(true)
                              }
                            >
                              <PersonAddAltIcon />
                            </IconButton>
                          </Tooltip>
                          {openModal ? (
                            <NewContact onClose={() => setOpenModal(false)} />
                          ) : (
                            ""
                          )}
                        </div>
                      </Box>
                    </div>
                  </div>

                  <button
                    className="clear-button"
                    onClick={() => {
                      setName("");
                      setRef("");
                      setKeyword("");
                      setSort("ASC");
                    }}
                  >
                    <Icon icon="ri:brush-3-line" width="20" height="20" />
                    Clear
                  </button>
                </div>

                <div className="row">
                  <div className="row_left">
                    <div className="position_left">
                      <div className="field_Container">
                        <TextField
                          className="textfieldRow2"
                          label="Keyword"
                          value={keyword}
                          onChange={(e) => setKeyword(e.target.value)}
                        />
                        <FormControl className="textfieldRow2">
                          <InputLabel>Sort Type</InputLabel>
                          <Select
                            label="Sort Type"
                            value={sort}
                            onChange={(e) => setSort(e.target.value)}
                          >
                            <MenuItem value="ASC">Ascending</MenuItem>
                            <MenuItem value="DESC">Descending</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                  </div>

                  <button
                    className="search-button"
                    onClick={() => {
                      setIsLoading(true);
                      fetchCustomer(keyword, 1, sort, name, ref);
                    }}
                  >
                    <Icon icon="mingcute:search-line" width="20" height="20" />
                    Search
                  </button>
                </div>
              </div>
            ) : (
              <div className="search-button-container">
                <div className="single_button">
                  <Tooltip title="Search" arrow>
                    <IconButton
                      size="medium"
                      onClick={() => setIsSearchShown(true)}
                    >
                      <Icon
                        icon="mingcute:search-line"
                        width="28"
                        height="28"
                      />
                    </IconButton>
                  </Tooltip>
                </div>
                <div className="Contact_Container_right">
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <div className="single_button knowledge_base">
                      <Tooltip title="Show knowledge base" arrow>
                        <IconButton
                          size="medium"
                          onClick={handleClickKnowledgeBase}
                        >
                          <Icon
                            height="26"
                            icon="material-symbols:quick-reference-outline"
                          />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </Box>

                  <Menu
                    anchorEl={anchorElKnowledgeBase}
                    open={openKnowledgeBase}
                    onClose={handleCloseKnowledgeBase}
                    onClick={handleCloseKnowledgeBase}
                    anchorOrigin={{ horizontal: -80, vertical: 70 }}
                  >
                    <MenuItem
                      onClick={() => setSelectedKnowledgeBase(KnowledgeBase1)}
                    >
                      Knowledge Base 1.pdf
                    </MenuItem>

                    <MenuItem
                      onClick={() => setSelectedKnowledgeBase(KnowledgeBase2)}
                    >
                      Knowledge Base 2.pdf
                    </MenuItem>
                  </Menu>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <div className="single_button">
                      <Tooltip title="Broadcast" arrow>
                        <IconButton
                          size="medium"
                          onClick={() => setIsBroadcastContactShown(true)}
                        >
                          <Icon
                            height="26"
                            icon="fluent:megaphone-loud-32-filled"
                          />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <div className="single_button">
                      <Tooltip title="Add Contact" arrow>
                        <IconButton
                          size="medium"
                          onClick={() => setIsAddEditContactDialogShown(true)}
                        >
                          <PersonAddAltIcon />
                        </IconButton>
                      </Tooltip>
                      {openModal ? (
                        <NewContact onClose={() => setOpenModal(false)} />
                      ) : (
                        ""
                      )}
                    </div>
                  </Box>
                </div>
              </div>
            )}
          </div>
          <div className="container_Body" id="infiniteScrollTarget">
            {isLoading ? (
              <Loader />
            ) : (
              <>
                {contact?.length === 0 && (
                  <p className="no-contact">No Contact Found</p>
                )}

                {isLinking && (
                  <div className="link-text">
                    <div className="single_button">
                      <Tooltip title="Cancel link" arrow>
                        <IconButton size="medium" onClick={handleCloseMerge}>
                          <Icon height="28" icon="tabler:x" width="28" />
                        </IconButton>
                      </Tooltip>
                    </div>

                    <p>Select another contact to link with</p>
                  </div>
                )}

                <InfiniteScroll
                  className="infinite-scroll"
                  dataLength={contact.length}
                  next={() =>
                    fetchCustomer(keyword, currentPage, sort, name, ref)
                  }
                  hasMore={hasMore}
                  loader={contact.length > 15 && <Loader />}
                  scrollableTarget="infiniteScrollTarget"
                  scrollThreshold={0.95}
                >
                  <Grid
                    container
                    columnSpacing={{
                      xs: "10px",
                      lg: "0px",
                    }}
                    rowSpacing={{
                      xs: "10px",
                      lg: "20px",
                    }}
                  >
                    {contact?.map((contactItem) => {
                      return (
                        <Grid
                          item
                          key={contactItem.ContactID}
                          xs={6}
                          sm={4}
                          md={2.4}
                          lg={2}
                          xl={1.7}
                        >
                          <ContactCard
                            data={contactItem}
                            contactList={contactList?.filter(
                              (contactListItem) =>
                                contactListItem.ContactID ===
                                contactItem.ContactID
                            )}
                            setIsContactDetailsModalShown={
                              setIsContactDetailsModalShown
                            }
                            setSelected={setSelected}
                            isLinkSource={
                              selected === contactItem.ContactID && isLinking
                            }
                            isLinking={isLinking}
                            setIsMergeWarningDialogShown={
                              setIsMergeWarningDialogShown
                            }
                            setMergeDestination={setMergeDestination}
                          />
                        </Grid>
                      );
                    })}
                  </Grid>
                </InfiniteScroll>
              </>
            )}
          </div>
        </div>
      )}

      {width <= 1200 && selected !== null && (
        <ContactDetails
          contactID={selected}
          setIsAddEditContactDialogShown={setIsAddEditContactDialogShown}
          setIsLinking={setIsLinking}
          setMergeSource={setMergeSource}
        />
      )}

      {width >= 1200 && (
        <ContactDetailsModal
          changePage={changePage}
          contactID={selected}
          isOpen={isContactDetailsModalShown}
          setIsContactDetailsModalShown={setIsContactDetailsModalShown}
          setSelected={setSelected}
          setIsAddEditContactDialogShown={setIsAddEditContactDialogShown}
          setIsLinking={setIsLinking}
          setMergeSource={setMergeSource}
        />
      )}

      <AddEditContactDialog
        isOpen={isAddEditContactDialogShown}
        contactID={selected}
        setIsAddEditContactDialogShown={setIsAddEditContactDialogShown}
        fetchCustomer={fetchCustomer}
        setSelected={setSelected}
        setIsContactDetailsModalShown={setIsContactDetailsModalShown}
      />

      <Dialog
        open={isMergeWarningDialogShown}
        className="dialog merge-warning"
        fullWidth
        maxWidth="sm"
        scroll="paper"
        onClose={() => {
          setIsMergeWarningDialogShown(false);
          setMergeDestination({});
        }}
      >
        <div className="dialog-container">
          <div className="dialog-warning">
            <header>
              <Icon height="28" icon="ion:warning" width="28" />

              <p>Warning!</p>

              <Icon height="28" icon="ion:warning" width="28" />
            </header>

            <div className="warning-content">
              <p>
                {mergeSource?.name} will be merged into {mergeDestination?.name}
              </p>
              <p>Do you wish to continue?</p>
            </div>
            <div className="buttons">
              <button
                className="cancel"
                type="button"
                onClick={() => {
                  setIsMergeWarningDialogShown(false);
                  setMergeDestination({});
                }}
              >
                Cancel
              </button>

              <button
                className="confirm"
                disabled={isProcessingMerge}
                onClick={() => {
                  setIsProcessingMerge(true);

                  mergeCustomer({
                    contactid: mergeSource.id,
                    delcontactid: mergeDestination.id,
                  })
                    .then((response) => {
                      if (response.status) {
                        console.log("Success");

                        toast.success("Contacts merged successfully", {
                          autoClose: 3000,
                        });

                        setIsProcessingMerge(false);
                        handleCloseMerge();
                      } else {
                        console.log("error", response.error);
                        toast.error("Error merging contact", {
                          autoClose: 3000,
                        });
                        setIsProcessingMerge(false);
                        handleCloseMerge();
                      }
                    })
                    .catch((err) => {
                      console.log("err", err);
                      toast.error("Error merging contact", { autoClose: 3000 });
                      setIsProcessingMerge(false);
                      handleCloseMerge();
                    });
                }}
              >
                {isProcessingMerge && <CircularProgress className="progress" />}
                Confirm
              </button>
            </div>
          </div>
        </div>
      </Dialog>

      {selectedKnowledgeBase && (
        <NewWindow
          url={selectedKnowledgeBase}
          onUnload={() => setSelectedKnowledgeBase(null)}
        />
      )}
    </div>
  );
}
